export enum PreferencePerPage {
    first = 100,
    second = 500,
    third = 1000,
    displayNoOfPagesPerPage =10
}